import { useForm } from "react-hook-form"
import { useNavigate} from "react-router-dom"
import { useContext, useEffect } from "react"
import { ToastDataContext } from "../context/ToastContextProvider"
import useSWR from "swr"
import { UserDataContext } from "../context/UserContextProvider"
import { hrInfoLocatieRezervariEndpoint } from "../hr_endpoints"
import ErrorManagement from "../components/errormanagement"
import CustomButton from "../components/button"
import { useTranslation } from "react-i18next"


export default function SettingsExtraInfoSala() {

    const { t } = useTranslation();

    const { data, error } = useSWR(hrInfoLocatieRezervariEndpoint)

    const { register, handleSubmit, formState: { errors }, reset } = useForm()

    const toastContext = useContext(ToastDataContext)
    const userContext = useContext(UserDataContext)
    const navigate = useNavigate()

    useEffect(() => {
        if (error) toastContext.error(error.message)
    }, [error])

    useEffect(() => {
        if (data) {
            reset({
                info_locatie_rezervari: data.info_locatie_rezervari
            })
        }
    }, [data])

    const onSubmit = async (data) => {
        const response = await fetch(hrInfoLocatieRezervariEndpoint, {
            method: "PUT",
            body: JSON.stringify(data),
            headers: {
                "Authorization": `Bearer ${userContext.user?.token}`,
                "Content-Type": "application/json"
            }
        })

        if (response.status === 401) {
            userContext.setUserData({})
            navigate('/login')
            toastContext.error("Sesiunea a expirat");
        }

        if (response.ok) {
            toastContext.success("Informațiile au fost actualizate cu succes")
        } else {
            toastContext.error(await response.text())
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="mt-6">
            <div className="grid gap-2">
                <div>
                    <div>
                        <label htmlFor="reason" className="block font-subtitle text-neutral-1100 mb-2">{t('settings.extraInfoSala')}</label>
                        <textarea {...register('info_locatie_rezervari')} placeholder={t('settings.extraInfoSala')} rows={6} className="w-full rounded-lg text-neutral-400 py-2 px-4 border border-neutral-border focus:outline-none bg-white" />
                    </div>
                    <ErrorManagement errorObj={errors.info_locatie_rezervari} />
                </div>
            </div>
            <CustomButton className="m-5" type={"submit"}>{t('settings.save')}</CustomButton>
        </form>
    )
}